import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { HomeComponent } from './pages/home/home.component';
import { MenusComponent } from './shared/components/menus/menus.component';
import { GestionSgmmComponent } from './pages/gestion-sgmm/gestion-sgmm.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { CatalogosComponent } from './pages/catalogos/catalogos.component';
import { RolesComponent } from './pages/roles/roles.component';
import { BeneficiariosComponent } from './pages/beneficiarios/beneficiarios.component';
import { HistoricoComponent } from './pages/historico/historico.component';
import { MsalGuard } from '@azure/msal-angular';
export const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: {
      routeIdx: 0,
    },
  },
  {
    canActivate: [MsalGuard],
    path: '',
    component: InicioComponent,
    data: {
      routeIdx: 1,
    },
    children: [
      {
        path: 'home',
        component: HomeComponent,
        data: {
          routeIdx: 2,
        },
      },
      {
        path: 'consulta-sgmm',
        component: GestionSgmmComponent,
        data: {
          routeIdx: 4,
        },
      },
      {
        path: 'reportes',
        component: ReportesComponent,
        data: {
          routeIdx: 5,
        },
      },
      {
        path: 'catalogos',
        component: CatalogosComponent,
        data: {
          routeIdx: 6,
        },
      },
      {
        path: 'roles',
        component: RolesComponent,
        data: {
          routeIdx: 7,
        }
      },
      {
        path: 'beneficiarios',
        component: BeneficiariosComponent,
        data: {
          routeIdx: 8,
        }
      },
      {
        path: 'historico',
        component: HistoricoComponent,
        data: {
          routeIdx: 9,
        }
      }
     ],
  },
  { path: '**', redirectTo: '/' }
];
